import { useQuery } from 'react-query'

import { DataSyncStatus } from '../../../types/dataSync'
import { get } from '../../../utils/api'

/**
 * The banner shows relative times ("checked 4 minutes ago"), which go stale on
 * the screen of anyone leaving the page open, hence the refetch interval.
 */
export const useDataSyncStatus = () =>
  useQuery<DataSyncStatus>(
    ['data-sync-status'],
    () => get<DataSyncStatus>('/data-sync-status/'),
    {
      retry: false,
      refetchInterval: 60_000,
    }
  )
